import { observer } from 'mobx-react-lite';
import 'semantic-ui-css/semantic.min.css';
import { Header, Form, Table, Button, Select, Input } from 'semantic-ui-react';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useStore } from '../../app/stores/store';
import { shiftMasterData } from '../../app/models/adlData';
function ShiftMaster() {
  const { ADLtrackingStore } = useStore();
  const outTimeHoursRef = React.createRef();
  const [selectedInHour, setSelectedInHour] = useState('00');
  const [selectedOutHour, setSelectedOutHour] = useState('00');
  const [selectedIntimeMinute, setSelectedIntimeMinute] = useState('00');
  const [selectedOuttimeMinute, setSelectedOuttimeMinute] = useState('00');
  const [selectedShift, setselectedShift] = useState('');
  const [shiftCodeMat, setshiftCodeMat] = useState('');
  const formattedInTime = `${selectedInHour}:${selectedIntimeMinute}`;
  const formattedOutTime = `${selectedOutHour}:${selectedOuttimeMinute}`;
  const [shiftDetails, setshiftDetails] = useState<shiftMasterData[]>([]);

  useEffect(() => {
    try {
      ADLtrackingStore.getAllshiftDetails().then(() => {
        setshiftDetails(ADLtrackingStore.newShiftDetails);
      });
    } catch (error) {
      toast.error('Error loading shift data:');
    }
    //eslint-disable-next-line
  }, []);

  const handleInTimeChange = (event: any, { value }: { value: string }) => {
    if (
      selectedOutHour === '00' ||
      selectedShift === 'Night Shift' ||
      parseInt(value) <= parseInt(selectedOutHour)
    ) {
      setSelectedInHour(value);
    } else {
      toast.error('Please select an out time greater than the in time');
      if (outTimeHoursRef.current) {
        const selectElement = outTimeHoursRef.current as HTMLDivElement;
        const select = selectElement.querySelector('select');
        if (select) {
          select.focus();
        }
      }
    }
  };
  const handleOutTimeChange = (event: any, { value }: { value: string }) => {
    if (
      parseInt(value) >= parseInt(selectedInHour) ||
      selectedShift === 'Night Shift'
    ) {
      setSelectedOutHour(value);
    } else {
      toast.error('Please select an out time greater than the in time');
      if (outTimeHoursRef.current) {
        const selectElement = outTimeHoursRef.current as HTMLDivElement;
        const select = selectElement.querySelector('select');
        if (select) {
          select.focus();
        }
      }
    }
  };
  const handleInMinuteChange = (event: any, { value }: { value: string }) => {
    setSelectedIntimeMinute(value);
  };
  const handleOutMinuteChange = (event: any, { value }: { value: string }) => {
    setSelectedOuttimeMinute(value);
  };

  const shiftNameHandler = async (event: any, data: any) => {
    const { value } = data;
    const selectedOption = shiftOption.find((option) => option.value === value);

    if (selectedOption) {
      setselectedShift(value);
      const test = await ADLtrackingStore.shiftNameCountUpdate(value);
      let setShiftCode = '';
      let ss = test;
      if (test === 0) {
        setShiftCode = selectedOption.shiftCodes;
      } else {
        setShiftCode = selectedOption.shiftCodes + ss;
      }
      setshiftCodeMat(setShiftCode);
    }
  };

  const loaddata = async () => {
    try {
      ADLtrackingStore.getAllshiftDetails().then(() => {
        setshiftDetails(ADLtrackingStore.newShiftDetails);
      });
    } catch (error) {
      toast.error('Error loading shift data:');
    }
  };

  const saveHandler = async () => {
    let payLoadData = {
      shiftCode: shiftCodeMat,
      shiftName: selectedShift,
      inTime: formattedInTime,
      outTime: formattedOutTime,
    };
    await ADLtrackingStore.addNewShiftDetails(payLoadData);
    loaddata();
  };
  const hourOptions = [
    { key: '0', text: '00', value: '00' },
    { key: '1', text: '01', value: '01' },
    { key: '2', text: '02', value: '02' },
    { key: '3', text: '03', value: '03' },
    { key: '4', text: '04', value: '04' },
    { key: '5', text: '05', value: '05' },
    { key: '6', text: '06', value: '06' },
    { key: '7', text: '07', value: '07' },
    { key: '8', text: '08', value: '08' },
    { key: '9', text: '09', value: '09' },
    { key: '10', text: '10', value: '10' },
    { key: '11', text: '11', value: '11' },
    { key: '12', text: '12', value: '12' },
    { key: '13', text: '13', value: '13' },
    { key: '14', text: '14', value: '14' },
    { key: '15', text: '15', value: '15' },
    { key: '16', text: '16', value: '16' },
    { key: '17', text: '17', value: '17' },
    { key: '18', text: '18', value: '18' },
    { key: '19', text: '19', value: '19' },
    { key: '20', text: '20', value: '20' },
    { key: '21', text: '21', value: '21' },
    { key: '22', text: '22', value: '22' },
    { key: '23', text: '23', value: '23' },
  ];

  const minutesOptions = [
    { key: '0', text: '00', value: '00' },
    { key: '1', text: '01', value: '01' },
    { key: '2', text: '02', value: '02' },
    { key: '3', text: '03', value: '03' },
    { key: '4', text: '04', value: '04' },
    { key: '5', text: '05', value: '05' },
    { key: '6', text: '06', value: '06' },
    { key: '7', text: '07', value: '07' },
    { key: '8', text: '08', value: '08' },
    { key: '9', text: '09', value: '09' },
    { key: '10', text: '10', value: '10' },
    { key: '11', text: '11', value: '11' },
    { key: '12', text: '12', value: '12' },
    { key: '13', text: '13', value: '13' },
    { key: '14', text: '14', value: '14' },
    { key: '15', text: '15', value: '15' },
    { key: '16', text: '16', value: '16' },
    { key: '17', text: '17', value: '17' },
    { key: '18', text: '18', value: '18' },
    { key: '19', text: '19', value: '19' },
    { key: '20', text: '20', value: '20' },
    { key: '21', text: '21', value: '21' },
    { key: '22', text: '22', value: '22' },
    { key: '23', text: '23', value: '23' },
    { key: '24', text: '24', value: '24' },
    { key: '25', text: '25', value: '25' },
    { key: '26', text: '26', value: '26' },
    { key: '27', text: '27', value: '27' },
    { key: '28', text: '28', value: '28' },
    { key: '29', text: '29', value: '29' },
    { key: '30', text: '30', value: '30' },
    { key: '31', text: '31', value: '31' },
    { key: '32', text: '32', value: '32' },
    { key: '33', text: '33', value: '33' },
    { key: '34', text: '34', value: '34' },
    { key: '35', text: '35', value: '35' },
    { key: '36', text: '36', value: '36' },
    { key: '37', text: '37', value: '37' },
    { key: '38', text: '38', value: '38' },
    { key: '39', text: '39', value: '39' },
    { key: '40', text: '40', value: '40' },
    { key: '41', text: '41', value: '41' },
    { key: '42', text: '42', value: '42' },
    { key: '43', text: '43', value: '43' },
    { key: '44', text: '44', value: '44' },
    { key: '45', text: '45', value: '45' },
    { key: '46', text: '46', value: '46' },
    { key: '47', text: '47', value: '47' },
    { key: '48', text: '48', value: '48' },
    { key: '49', text: '49', value: '49' },
    { key: '50', text: '50', value: '50' },
    { key: '51', text: '51', value: '51' },
    { key: '52', text: '52', value: '52' },
    { key: '53', text: '53', value: '53' },
    { key: '54', text: '54', value: '54' },
    { key: '55', text: '55', value: '55' },
    { key: '56', text: '56', value: '56' },
    { key: '57', text: '57', value: '57' },
    { key: '58', text: '58', value: '58' },
    { key: '59', text: '59', value: '59' },
  ];

  const shiftOption = [
    {
      key: 'MNG',
      text: 'Morning Shift',
      value: 'Morning Shift',
      shiftCodes: 'MNG',
    },
    {
      key: 'GEN',
      text: 'General Shift',
      value: 'General Shift',
      shiftCodes: 'GEN',
    },
    {
      key: 'AFT',
      text: 'Afternoon Shift',
      value: 'Afternoon Shift',
      shiftCodes: 'AFT',
    },
    {
      key: 'NGT',
      text: 'Night Shift',
      value: 'Night Shift',
      shiftCodes: 'NGT',
    },
  ];
  return (
    <>
      <div className="title-wise-table ">
        <Form
          className="new-report-form-wrapper"
          style={{ width: '90%', margin: 'auto' }}
        >
          <Header>Shift Master</Header>
          <Form.Group widths="equal">
            <Form.Field
              control={Select}
              label="Shift Name"
              options={shiftOption}
              placeholder="Shift Name"
              onChange={shiftNameHandler}
            />
            <Form.Field
              disabled
              control={Input}
              label="Shift Code"
              placeholder="Shift Code"
              value={shiftCodeMat}
              readOnly
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field
              control={Select}
              label="In Time (Hours)"
              options={hourOptions}
              value={selectedInHour}
              search
              filter
              onChange={handleInTimeChange}
              placeholder="Select hour"
            />
            <Form.Field
              control={Select}
              label="In Time (Minutes)"
              options={minutesOptions}
              value={selectedIntimeMinute}
              search
              filter
              onChange={handleInMinuteChange}
              placeholder="Select minute"
            />
            <Form.Field>
              <label>In Time</label>
              <input type="text" value={formattedInTime} readOnly />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field
              control={Select}
              label="Out Time (Hours)"
              options={hourOptions}
              value={selectedOutHour}
              search
              filter
              onChange={handleOutTimeChange}
              placeholder="Select hour"
              ref={outTimeHoursRef}
            />
            <Form.Field
              control={Select}
              label="Out Time (Minutes)"
              options={minutesOptions}
              value={selectedOuttimeMinute}
              search
              filter
              onChange={handleOutMinuteChange}
              placeholder="Select minute"
            />
            <Form.Field>
              <label>Out Time</label>
              <input type="text" value={formattedOutTime} readOnly />
            </Form.Field>
          </Form.Group>
          <Form.Group style={{ justifyContent: 'end' }}>
            <Form.Field id="">
              <div></div>
              {/* <label style={{color:'white'}}> Click Here </label> */}
              <br />
              <Button.Group>
                <Button>Cancel</Button>
                <Button.Or />
                <Button positive onClick={saveHandler}>
                  Save
                </Button>
              </Button.Group>
            </Form.Field>
          </Form.Group>
        </Form>
        <br />
        <div
          className="new-report-form-wrapper"
          style={{ width: '90%', margin: 'auto' }}
        >
          <Header>Shift Details</Header>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Shift Code</Table.HeaderCell>
                <Table.HeaderCell>Shift Name</Table.HeaderCell>
                <Table.HeaderCell>In Time</Table.HeaderCell>
                <Table.HeaderCell>Out Time</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {shiftDetails?.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={4} textAlign="center">
                    Data is currently unavailable
                  </Table.Cell>
                </Table.Row>
              )}
              {Array.isArray(shiftDetails) &&
                shiftDetails.length !== 0 &&
                shiftDetails.map((Items, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{Items.shiftCode}</Table.Cell>
                    <Table.Cell>{Items.shiftName}</Table.Cell>
                    <Table.Cell>{Items.inTime}</Table.Cell>
                    <Table.Cell>{Items.outTime}</Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    </>
  );
}

export default observer(ShiftMaster);
